import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, currencyCovMap, formateDate } from "../../../../utils/commonfunction";
import * as usersServices from "../../services/users.services";
import { useTranslation } from "react-i18next";

const UserView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [latestTransaction, setLatestTransaction] = useState([]);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "User Management", url: "/admin/user/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    usersServices
      .Details(params.id)
      .then((response) => {
        setLatestTransaction(response?.data?.latestTransactions ?? []);
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  const renderImage = (imagePath, altText, imageKey, height = "100px") => {
    if (!imagePath) return "N/A";
    return <img src={imagePath} alt={altText || "User Image"} style={{ height, maxWidth: "200px", objectFit: "cover" }} className="img-thumbnail hover:scale-200" />;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View User Management</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault?.fullName) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Email")}</th>
                          <td>{showdefault?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>{showdefault?.phone_number?.fullNumber || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Country</th>
                          <td>{showdefault?.country || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>State</th>
                          <td>{showdefault?.state || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>City</th>
                          <td>{showdefault?.city || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{showdefault?.address ? capitalizeFirstLetter(showdefault.address) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Latitue/Longitude</th>
                          <td>{showdefault?.latitude && showdefault?.longitude ? `${showdefault.latitude}, ${showdefault.longitude}` : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>My Referral Code</th>
                          <td>{showdefault?.myReferralCode || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Post Code</th>
                          <td>{showdefault?.zip_code || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>{showdefault?.status !== undefined ? <span className={`badge ${showdefault?.status === 1 ? "bg-success" : "bg-danger"}`}>{showdefault?.status === 1 ? "Active" : "Inactive"}</span> : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Profile Image</th>
                          <td>{renderImage(showdefault?.profile_image, "Profile Image", "profile")}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <h6 className="main-content-label mb-3">View User Activity</h6>
                    </div>
                    {
                      // latestTransaction.length === 0  ? 
                      // <tr className="text-center">
                      //   <td className="m-2" colSpan="8">
                      //     No transactions found
                      //   </td>
                      // </tr> :
                      <table id="simple-table" className="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Offer Used</th>
                            <th>Amount</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Reference ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            latestTransaction.map((txn, index) => {
                              return (
                                <tr key={index}>
                                  <td>{new Date(txn.createdAt).toLocaleDateString("en-US", {year: "numeric",month: "long",day: "numeric",})}</td>
                                  <td>{txn.offer_id ? txn.offer[0].name : txn.offerPercentage + "%"}</td>
                                  <td>{txn.currency === "GBP" ? `£${txn.netPay}` : `${currencyCovMap[txn.currency.toUpperCase()] ?? '$'} ${txn.netPay}`}</td>
                                  <td>{capitalizeFirstLetter(txn.paymentMethod)}</td>
                                  <td>
                                    <span >{capitalizeFirstLetter(txn.status)}</span>
                                  </td>
                                  <td>{txn.transactionID}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    }

                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserView;
